import { addDays, taipeiToday } from "../../../src/utils/dates";

export function reportingToday(now = new Date()): string {
  return taipeiToday(now);
}

export function reportingDaysAgo(days: number, now = new Date()): string {
  return addDays(reportingToday(now), -days);
}

export function defaultReportingRange(now = new Date()): { from: string; to: string } {
  const to = reportingToday(now);
  return { from: addDays(to, -6), to };
}
